import AppConstants from "../../../../../config/app.constants";
import LocationDistanceBaseController from "../common/location_distance.base.controller";

class LocationDistanceCreateController extends LocationDistanceBaseController {
    /*@ngInject*/
    constructor(Auth, User, $state, $translate, $stateParams, $location, Modal, LocationDistanceService) {
        super(Auth, $state, User, LocationDistanceService, Modal, $translate, $stateParams)

        this.Auth = Auth;
        this.User = User;
        this.$state = $state;
        this.$translate = $translate;
        this.$stateParams = $stateParams;
        this.$location = $location;
        this.Modal = Modal;
        this.LocationDistanceService = LocationDistanceService;

        this.defaultModel = {
            locationDistanceObj: {
                totalRecords: 0,
                results: [],
                loading: false
            },
            pagination: {
                page: 1,
                total: 0,
                pageLimit: 10,
                maxPages: 10
            },
            errorMessage: '',
            branchId: User.getUser().branchId,
            searchText: '',
            label: null,
            mileRange: null,
            minRange:null,
            maxRange:null,
        }

        this.model = angular.copy(this.defaultModel);
    }

    $onInit() { }

    search() {
        this.pageChange();
    }

    edit(billableEvent) {
        this.$state.go('location_distance.edit', ({
            id: billableEvent.id
        }))
    }

    submit() {
        this.model.isCreate = true;
        delete this.model.errorMessage;

        this.Service.create({
            label: this.model.label,
            mileRange: this.model.mileRange,
            branchId: this.model.branchId,
            minRange: this.model.minRange,
            maxRange: this.model.maxRange,
        })
            .then(() => {
                this.askCreate();
            })
            .catch((err) => {
                if (err && err.data && err.data.message) {
                    this.model.errorMessage = err.data.message;
                }
                else {
                    err.data.errors.map((e) => {
                        this.model.errorMessage += e.message + '<br/>'
                    })
                }
            })
            .finally(() => {
                this.model.isCreate = false;
            })
    }

    reset() {
        this.model = angular.copy(this.defaultModel);
        this.validateRange();
        this.clearErrors();
    }

    validateRange() {
        let minRange = parseFloat(this.model.minRange);
        let maxRange = parseFloat(this.model.maxRange);

        if (minRange === maxRange) this.rangeError = this.$translate.instant('locationDistance.mileage_equal_distance_error')
        else if (maxRange < minRange) this.rangeError = this.$translate.instant('locationDistance.mileage_error')
        else this.rangeError = null;
    }
}

export default LocationDistanceCreateController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/location_distance/create/location_distance.create.controller.js